import React, { useState } from "react"
import SearchPlacesForm from "../SearchPlacesForm/SearchPlacesForm"

import style from "./ChangeAddressForm.module"

// ----------------------------------------------------------------------------

function ChangeAddressForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { deliveryAddress = undefined, apiKey, path } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [isAddressChangeRequested, setIsAddressChangeRequested] = useState(
    false
  )

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleChangeAddress() {
    setIsAddressChangeRequested(true)
  }

  function isFilled() {
    return (
      !!deliveryAddress.latitude &&
      !!deliveryAddress.longitude &&
      !!deliveryAddress.street_name &&
      !!deliveryAddress.city
    )
  }

  function formatAddress(deliveryAddress) {
    return isFilled(deliveryAddress)
      ? `${deliveryAddress?.street_name || ""}${
          deliveryAddress?.street_number
            ? " " + deliveryAddress?.street_number
            : ""
        }, ${deliveryAddress?.city}`
      : ""
  }

  function getAddress() {
    return formatAddress(deliveryAddress)
  }

  function renderChangeAddress() {
    if (isFilled() && !isAddressChangeRequested) {
      return (
        <div>
          <span className={style.currentDeliveryAddress}>
            {I18n.t("pages.venues.show.change_address_form.delivery_in", {
              address: getAddress(),
            })}
          </span>
          <span
            className={style.changeDeliveryAddressLink}
            onClick={handleChangeAddress}
          >{` - ${I18n.t(
            "pages.venues.show.change_address_form.change_address"
          )}`}</span>
        </div>
      )
    } else {
      return (
        <SearchPlacesForm
          placeholder={I18n.t("pages.locations.search_form.placeholder")}
          deliveryAddress={deliveryAddress}
          apiKey={apiKey}
          path={path}
        />
      )
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return <div className={props.className}>{renderChangeAddress()}</div>
}

// ----------------------------------------------------------------------------

export default ChangeAddressForm
